// extracted by mini-css-extract-plugin
export default {"body":"barn-list_body__3LBMc","strong":"barn-list_strong__ytuy6"};